<template>
  <nav>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          data-testid="edit-name-button"
          v-bind="attrs"
          icon
          absolute
          right
          top
          class="mt-n2 mr-n2"
          v-on="on"
          @click="$emit('proceedSubmit', '', '')"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card data-testid="edit-space-name-card">
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="updateSpaceName"
          @submit.prevent
        >
          <v-toolbar
            dark
            color="accent"
          >
            <v-btn
              data-testid="close-button"
              icon
              dark
              @click="reloadForm"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-h5 font-weight-bold">
              {{ $t('editSpaceNameTitle') }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              data-testid="submit-button"
              type="submit"
              :disabled="loading"
              color="white"
              class="text-body-1 darktext--text text-none rounded-xxl px-4"
              @click="updateSpaceName"
            >
              {{ $t('save') }}
            </v-btn>
          </v-toolbar>
          <AlertMessages
            v-if="alertValue"
            alert-type="error" 
            :alert-msg="alertMsg"
            @reset="alertValue = false"
          />
          <v-card-text class="pt-0 pl-6"> 
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="py-15 px-md-12">
                  <p class="font-weight-bold text-h6 darktext--text">
                    {{ $t('labelSpaceName') }}
                  </p>
                  <v-text-field
                    v-model="name"
                    data-testid="space-name-input"
                    solo
                    hide-details="auto"
                    elevation="6"
                    class="rounded-xxl text-body-2 mb-5"
                    :rules="spaceNameRules"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { updateSpace } from '../../api/spaceApi'
import { ruleRequired, ruleValidMin2Characters } from '../../rules/formRules.js';
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        AlertMessages
    },
    props: {
        spaceName: {
          type: String,
          default: ''
        }
    },
    data(){
        return{
            dialog: false,
            valid: true,
            alertMsg: '',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            loading: false,
            spaceNameRules: ruleRequired('labelSpaceName').concat(ruleValidMin2Characters('labelSpaceName')),
            val: ''
         }
    },
    computed: {
        name:
        {
            get()
            {
                return this.val
            },
            set(spaceName)
            {
                this.val = spaceName
            }
        }
    },
    watch: {
        spaceName(newVal) {
            this.val = newVal
        }
    },
    methods: {
        async updateSpaceName(){
            this.$refs.form.validate()
            if(this.valid){
                this.loading = true
                var alertType = ''
                var alertMsg = ''
                try {
                    let data = {
                        data: {
                            type: "spaces", 
                            id: this.spaceId,
                            attributes: {
                                name: this.name.trim()
                            }
                        }
                    };
                    const response = await updateSpace(this.spaceId, data)
                    if(response.status == 200) {
                        alertMsg =  i18n.t('editSpaceNameSuccess')
                        alertType = 'success'
                        localStorage.space = JSON.stringify(response.data.data.attributes)
                        this.$emit('proceedSubmit', alertMsg, alertType)
                        this.reloadForm()
                    }
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                         if (e.response.status == 422 ){
                            for(let i = 0; i < e.response.data.errors.length; i++){
                                if(e.response.data.errors[i].detail == 'The name has already been taken.'){
                                    this.alertType = 'error'
                                    this.alertMsg =  i18n.t('createSpaceErrorNameAlreadyTaken')
                                }
                                else {
                                    alertType = 'error'
                                    alertMsg =  i18n.t('serverError')
                                    this.$emit('proceedSubmit', alertMsg, alertType)
                                    this.reloadForm()
                                }
                            }
                        }
                        else{
                            alertType = 'error'
                            alertMsg =  i18n.t('serverError')
                            this.$emit('proceedSubmit', alertMsg, alertType)
                            this.reloadForm()
                        }
                    }
                }
                this.loading = false
            }
        },
        reloadForm(){
            this.dialog = false,
            this.alertMsg = '',
            this.name = this.spaceName
        }
    }
}
</script>